<template>
  <v-container>
    <v-img max-height="400px" contain src="../assets/smrt-bygg-fg.png"></v-img>
        <v-row justify="center" class="align-center">
          <v-col cols="12" md="6">
                      <v-img class="rounded" contain src="../assets/smrt-bygg-mock.png"></v-img>
          </v-col>
          <v-col cols="12" md="6">
            <v-card flat style="border-radius: 25px; background-color: rgba(0,0,0,0)" class="text-center align-center justify-center">
            <div style="margin: 5em">
              <h2 style="margin: 1em">
                Intelligente bygg
              </h2>
              <ul>
                <li>Senk energi og driftskostnader</li>
                <li>Integrer med eksisterende anlegg</li>
                <li>Automatiser på kryss av systemer</li>
              </ul>
              <v-card-actions class="text-center align-center justify-center">
                <v-btn class="primary" style="margin-top: 1em; padding: 0 3em 0 3em"
                       rounded depressed to="/bms">
                  Les mer
                </v-btn>
              </v-card-actions>
            </div>
          </v-card>
          </v-col>

          <v-col class="align-center text-center" cols="12">

            <v-row justify="space-around">
              <v-col>
                <v-avatar size="256">
                  <v-img src="../assets/landscape-ipad-mini-mockup-of-a-female-architect-at-work-a12568.png"></v-img>
                </v-avatar>
                <p>For installatører</p>
              </v-col>

              <v-col>
                <v-avatar size="256">
                  <v-img src="../assets/ipad-mockup-in-landscape-position-featuring-a-smiling-woman-in-a-bus-12957s.png"></v-img>
                </v-avatar>
                <p>For byggeiere</p>
              </v-col>

              <v-col>
                <v-avatar size="256">
                  <v-img src="../assets/t-shirt-mockup-featuring-a-young-student-taking-notes-in-a-classroom-m12980-r-el2.png"></v-img>
                </v-avatar>
                <p>For fremtiden</p>
              </v-col>

            </v-row>
          </v-col>

        </v-row>


<!-- TrackSense section -->
<!--    <v-img max-height="400px" contain src="../assets/tracksense-logo.png"></v-img>-->
    <v-row justify="center" class="align-center">
      <v-col cols="12" md="6">
<!--        <v-img class="rounded" contain src="../assets/firmabiler.png"></v-img>-->
      </v-col>
      <v-col cols="12" md="6">
        <v-card flat style="border-radius: 25px; background-color: rgba(0,0,0,0)" class="text-center align-center justify-center">
          <div style="margin: 5em">
<!--            <h2 style="margin: 1em">-->
<!--              Digital kjørebok og GPS sporing-->
<!--            </h2>-->
<!--            <ul>-->
<!--              <li>Full kontroll på eiendeler</li>-->
<!--              <li>Enklere hverdag for dine ansatte</li>-->
<!--              <li>Enkel rapportering til skatteetaten</li>-->
<!--            </ul>-->
<!--            <v-card-actions class="text-center align-center justify-center">-->
<!--              <v-btn class="primary" style="margin-top: 1em; padding: 0 3em 0 3em"-->
<!--                     rounded depressed to="/tracksense">-->
<!--                Les mer-->
<!--              </v-btn>-->
<!--            </v-card-actions>-->
          </div>
        </v-card>
      </v-col>



    </v-row>


</v-container>

</template>

<script>
  // import SlideShow from "@/components/Slideshow";
  // import BMSView from "@/views/BMS";
  // import SystemsView from "@/views/Systems";
  export default {
    name: 'Home-view',

    components: {
      // SlideShow
      // BMSView,
      // SystemsView,
    },
    data: () => ({
      fab: false,
      cards: [
          {
            icon: 'mdi-lightbulb',
            title: 'SMART LYSSTYRING',
            text: 'Intelligent styring av lys ved bruk av blant annet bevegelses- og lyssensorer, samt smarte tidsplaner, gir lavere energiforbruk og bedre innemiljø. Varslinger når lyspærer og rør må byttes sparer driftere av bygg enormt med tid.',
          },
          {
            icon: 'mdi-air-filter',
            title: 'SMART VENTILASJON',
            text: 'Intelligent styring og monitorering av HVAC basert på flere sensorer sørger for optimalt inneklima og energiforbruk, i tillegg varslinger ved feil.',
          },
          {
            // icon: 'mdi-thermostat',
            icon: 'mdi-thermometer',
            title: 'SMART VARME',
            text: 'Intelligent styring av varme ved bruk av sensorer og smart programmering gir bedre innemiljø og lavere energiforbruk.',
          },
          {
            icon: 'mdi-leaf',
            title: 'INNEKLIMA MÅLINGER',
            text: 'Kontinuerlig inneklima målinger, blant annet temperatur, fukt, CO2 og luftkvalitet gir godt grunnlag for dokumentasjon og driftere av bygg sparer tid på å slippe manuelle kontroller.',
          },
          {
            icon: 'mdi-account-group',
            title: 'STØV OG TILSTEDEVÆRELSE',
            text: 'Monitorering av støv og hvor mye lokaler har vært i bruk, bidrar til besparelser ved å minske unødvendig vasking.',
          },
          {
            icon: 'mdi-cellphone',
            title: 'FJERNSTYRING',
            text: 'Elementer i byggene kan enkelt fjernstyres via mobil app eller dashboard.',
          },
          {
            icon: 'mdi-alert',
            title: 'SIKKERHET OG VARSLING',
            text: 'Kontinuerlig oversikt over status på komponenter i byggene og tidlige varslinger ved avvik bidrar til enklere og billigere drift.',
          },
          {
            icon: 'mdi-content-copy',
            title: 'RAPPORTERING',
            text: 'Innsamling av sensordata i skyen gir enkel oversikt og dokumentasjon, og grunnlag for ytterligere besparelser og effektivisering.',
          },
          {
            icon: 'mdi-server',
            title: 'PLATTFORM',
            text: 'En felles åpen plattform og tjenester i skyen sørger for datainnsamling og samhandling med andre systemer.',
          },
      ]
    }),
    mounted () {
      window.scrollTo(0, 0)
    },
    methods: {
      onClick() {
        console.log('clicked.')
      }
    }
  }
</script>
<style>

main {
  background: linear-gradient(135deg, rgba(5,71,160,0.8) 0%, rgba(5,71,160,0) 65%, rgba(5,71,160,0.2) 100%);
}

.v-btn {
  text-transform:none !important;
}
.interest-bar {
  margin-top: 5em;
}
.interest-grid {
  display: grid;
  gap: 1em;
  grid-template-columns: 1fr 1fr 1fr;
}
.interest-cards {
  cursor: pointer;
  height: 200px;
  overflow: hidden;
}


/*main {*/
/*!*  background: linear-gradient(-45deg, rgba(100,100,255,0.8), rgba(255,255,255,0.2), rgba(35,166,213,0.6), rgba(35,213,171,0.3));*!*/
/*!*  !*background: linear-gradient(-45deg,rgba(100,100,255,0.6),rgba(35,166,213,0.6), rgba(35,213,171,0.3));*!*!*/
/*!*  !*background: linear-gradient(135deg, rgba(5,71,160,1) 0%, rgba(5,71,160,0) 100%);*!*!*/
/*background: linear-gradient(135deg, rgba(5,71,160,1), rgba(5,71,160,0.1));*/
/*  background-size: 400% 400%;*/
/*  animation: gradient 20s ease-in-out infinite;*/
/*}*/

/*@keyframes gradient {*/
/*  0% {*/
/*    background-position: 50% 50%;*/
/*  }*/
/*  25% {*/
/*    background-position: 100% 25%;*/
/*  }*/
/*  50% {*/
/*    background-position: 85% 100%;*/
/*  }*/
/*  75% {*/
/*    background-position: 25% 100%;*/
/*  }*/
/*  100% {*/
/*    background-position: 50% 50%;*/
/*  }*/
/*}*/

</style>
